export enum CompanyType {
  Private = "private",
  Public = "public",
}
